export class ListenerUtils {
    static newListenerKey(where) {
        let pos = Math.round(Math.random() * 10000);
        while (where.has(pos)) {
            pos = Math.round(Math.random() * 10000);
        }
        return pos;
    }
    static removeListener(listeners, listener) {
        if (typeof listener == 'number') {
            if (listeners.has(listener)) {
                listeners.delete(listener);
            }
        }
        else {
            const key = [...listeners.entries()]
                .find(({ 1: val }) => val == listener);
            if (key) {
                listeners.delete(key[0]);
            }
        }
    }
}
//# sourceMappingURL=listener_utils.js.map